export default __webpack_public_path__ + "static/media/metro.929cde3c.svg";